import { Button } from '@mui/material'
import { styled } from '@mui/material/styles'
import { Theme } from '@mui/material/styles'

/**
 * Centralized button styled components and styles
 * Use these instead of repeating button styles across components
 */

/**
 * Primary save button - blue
 */
export const SaveButton = styled(Button)(() => ({
  backgroundColor: 'rgb(42, 128, 200)',
}))

/**
 * Edit button - orange with dark text
 */
export const EditButton = styled(Button)(({ theme }) => ({
  color: 'rgba(0,0,0,1)',
  fontWeight: 'bold',
  backgroundColor: 'rgb(251, 192, 147)',
  '&:hover': {
    color: theme.palette.mode === 'dark' ? 'rgba(255,255,255,1)' : '',
  },
}))

/**
 * Create button - green
 */
export const CreateButton = styled(Button)(() => ({
  backgroundColor: 'rgb(29, 106, 82)',
}))

/**
 * Header button - green with white text
 */
export const HeaderButton = styled(Button)(({ theme }) => ({
  backgroundColor: 'rgb(29, 106, 82)',
  color: theme.palette.mode === 'dark' ? 'white' : 'white',
}))

/**
 * Delete button styles (for use with sx prop)
 */
export const deleteButtonStyles = (theme: Theme) => ({
  borderColor: 'black',
  color: 'red',
  fontWeight: 'bold',
  ':hover': {
    backgroundColor: 'rgba(201, 50, 46)',
    borderColor: 'black',
    color: theme.palette.mode === 'dark' ? 'white' : 'black',
  },
})

/**
 * Delete icon styles (for use with sx prop)
 */
export const deleteIconStyles = (theme: Theme) => ({
  borderColor: 'black',
  fontSize: 30,
  color: 'red',
  fontWeight: 'bold',
  ':hover': {
    backgroundColor: 'rgba(201, 50, 46)',
    borderColor: 'black',
    borderRadius: '24px',
    color: theme.palette.mode === 'dark' ? 'white' : 'black',
  },
})
